<template>
  <div class="bg-white rounded-2xl shadow-md p-6 space-y-4">
    <h2 class="text-lg font-bold">Facturation</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4">
      <StackedField label="Modèle de rémunération">
        <Selector
          id="remunerationModel"
          name="remunerationModel"
          v-model="remunerationModelValue"
          :options="remunerationModelOptions"
        />
      </StackedField>
      <StackedField label="Niveau de facturation">
        {{ $t(`organization.invoice_level.${invoiceLevel}`) }}
      </StackedField>
      <StackedField label="Délai de facturation">
        {{ store.billingDelay || "—" }}
      </StackedField>
      <StackedField label="Taux de churn accepté">
        {{ churnRate || "—" }}
      </StackedField>
    </div>
    <div class="flex justify-end gap-x-3">
      <SecondaryButton @click="$emit('previous')">Retour</SecondaryButton>
      <SecondaryButton @click="submit" :loading="saving">Continuer</SecondaryButton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { StackedField, Selector, SecondaryButton } from "@estaly/ui";

export default {
  name: "StoreOnboardingStepBilling",
  components: { StackedField, Selector, SecondaryButton },
  props: { store: { type: Object, required: true } },
  emits: ["step-completed", "previous"],
  data() {
    return {
      saving: false,
      remunerationModelValue: this.store.remunerationModel || "classic",
    };
  },
  computed: {
    ...mapGetters("stores", ["effectiveInvoiceLevel", "getRemunerationModels"]),
    invoiceLevel() {
      return this.effectiveInvoiceLevel(this.store);
    },
    churnRate() {
      return this.store.churnRate != null ? `${(this.store.churnRate * 100).toFixed(2)} %` : null;
    },
    remunerationModelOptions() {
      return this.getRemunerationModels().map((v) => ({
        value: v,
        label: this.$t(`store.remuneration_model.${v}`),
      }));
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("stores", ["update"]),
    async submit() {
      this.saving = true;
      const response = await this.update({
        storeId: this.store.id,
        data: { remunerationModel: this.remunerationModelValue },
      });
      this.saving = false;
      if (!response?.success) return;

      await this.notify({ category: "simple", type: "success", title: "Facturation enregistrée" });
      this.$emit("step-completed");
    },
  },
};
</script>
